"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Range", {
    enumerable: true,
    get: function() {
        return Range;
    }
});
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Range = function(props) {
    var className = props.className, id = props.id, name = props.name, min = props.min, max = props.max, step = props.step, onChange = props.onChange, defaultValue = props.defaultValue;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("input", {
        className: (0, _classnames.default)("mb-6 w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm outline-none", {
            className: className
        }),
        type: "range",
        id: id,
        name: name,
        min: min,
        max: max,
        step: step,
        onChange: onChange,
        defaultValue: defaultValue
    }));
};

//# sourceMappingURL=Range.js.map